import React, { memo } from 'react';
import renderRow from './renderRow';
import ErrorRow from './ErrorRow';
import _ from 'lodash';

/**
 * Table Component
 *
 * This component renders a dynamic table based on the provided columns and data.
 * Each item in the data array specifies a "type," which is mapped to a row component
 * (e.g., NormalRow, IndentedRow, etc.). Basic error handling covers invalid columns,
 * missing row properties (like "type"), or empty data arrays.
 *
 * Props:
 * - columns: Array<{ key: string, label: string }>
 *    Defines the table headers, each with a unique 'key' and display 'label'.
 * - data: Array<{
 *     id: string | number,
 *     type: string,
 *     data: any
 *   }>
 */
const Table = ({ columns, data }) => {
  if (!_.isArray(columns) || _.isEmpty(columns) || !_.isArray(data) || _.isEmpty(data)) {
    return (
      <ErrorRow message="There is no data available to display the table." columns={1} standalone />
    );
  }

  return (
    <div className="rounded-t-lg overflow-x-auto">
      <table className="w-full text-sm border-collapse">
        {/* Header */}
        <thead className="bg-[#DBDBDB]">
          <tr>
            {columns.map((col, index) => (
              <th
                key={col.key}
                className={`py-2 px-4 font-semibold text-center text-black ${
                  index === 0 ? 'pl-[50px]' : ''
                }`}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>

        {/* Body */}
        <tbody>{data.map((row) => renderRow(row, columns))}</tbody>
      </table>
    </div>
  );
};

export default memo(Table);
